import { render, staticRenderFns } from "./PxCriterioCadastroAdicional.vue?vue&type=template&id=7fe6752a&"
import script from "./PxCriterioCadastroAdicional.vue?vue&type=script&lang=js&"
export * from "./PxCriterioCadastroAdicional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports